export default function ScrollSmooth() {
	if (window.screen.width > 992) {
		const lenis = new Lenis();

		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}

		requestAnimationFrame(raf);
		
		window.lenis = lenis;
	}
}